import styled from 'styled-components'

const TypoIntroWrapper = styled.div`
  width: var(--typo-intro-width);
`

export default TypoIntroWrapper
